import type { IPhoneNumber } from "~/types/people-os"
import { toDialableE164 } from "~/utils/format-phone-number"

export type DialNumber = {
  phone: string
  label: string
}

const POSITION_LABELS = ["Primary", "Secondary", "Other"]

function labelAt(index: number) {
  return POSITION_LABELS[index] ?? POSITION_LABELS[POSITION_LABELS.length - 1]
}

function dedupeKey(phone: string) {
  return phone.replace(/\D/g, "")
}

export function orderedDialNumbers(person: {
  phone?: string
  phone_numbers?: IPhoneNumber[]
  location_country?: string
  tz?: string
}): DialNumber[] {
  const candidates: string[] = []
  for (const entry of person.phone_numbers ?? []) {
    if (entry?.phone) candidates.push(entry.phone)
  }
  if (person.phone) candidates.unshift(person.phone)

  const seen = new Set<string>()
  const out: DialNumber[] = []
  for (const raw of candidates) {
    const normalised = toDialableE164(raw, person.location_country, person.tz)
    if (!normalised) continue
    const key = dedupeKey(normalised)
    if (!key || seen.has(key)) continue
    seen.add(key)
    out.push({ phone: normalised, label: labelAt(out.length) })
  }
  return out
}
